export const dealPaymentOptions = {
  NOT_PAID: 'No',
  PAID: 'Sí',
  OBSERVATIONS: 'App Consumer',
}